import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { config } from '../../../config';

interface StorageResponse {
  data: {
    path: string;
    url: string;
  };
}

@Injectable()
export class StorageService {
  constructor(private http: HttpClient) {}

  upload(file: File) {
    const body = new FormData();
    body.append('file', file, file.name);

    return this.http
      .post<StorageResponse>(`${config.apiLocation}/v1/storage`, body)
      .map(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/storage.service.ts